<template>
  <div class="vuestic-modal">
    <transition name="modal" :duration="duration">
      <div v-show="show" class="modal-container">
        <div class="modal" @click.self="clickMask">
          <div class="modal-dialog" :class="modalClass">
            <div class="modal-content">
              <!--Header-->
              <div class="modal-header">
                <slot name="header">
                  <div class="modal-title">
                    <slot name="title"></slot>
                  </div>
                  <i
                    class="ion ion-md-close close-modal"
                    v-if="closeIconShown"
                    @click.prevent="cancel"
                  />
                </slot>
              </div>

              <!--Container-->

              <div class="modal-body">
                <slot></slot>
                <form>
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                      <fieldset>

                        <div v-if="izbor === 'jmbg'">
                          <div class="form-group with-icon-left">
                            <div class="input-group">
                              <input  style="color: #e34a4a"
                                onpaste="return false;"
                                autocomplete="off"
                                id="jmbp-input-icon-left"
                                title=" "
                                v-model="patient.jmbg"
                                name="jmbp-input-icon-left"
                                required
                              >
                              <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                              <label  style="color: #e34a4a"
                                class="control-label"
                                for="jmbp-input-icon-left"
                              >{{'DD MM GGG RR BBB K'}}</label>
                              <i class="bar"></i>
                            </div>
                          </div>
                        </div>

                        <vuestic-simple-select  :color="'red'"
                          :label="'Izaberite spol pacijenta'"
                          v-model="patient.spol"
                          name="spol"
                          :required="true"
                          title=" "
                          ref="spolSelect"
                          v-bind:options="spolovi"
                        ></vuestic-simple-select>

                      <div class="form-group with-icon-left">
                          <div class="input-group">
                            <input
                            
                              id="passport-input-icon-left"
                              title=" "
                              v-model="patient.ljekar"
                              name="passport-input-icon-left"
                              required
                            >
                            <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                            <label
                            
                              class="control-label"
                              for="passport-input-icon-left"
                            >{{'LJekar'}}</label>
                            <i class="bar"></i>
                          </div>
                        </div>

                      <div class="form-group with-icon-left">
                          <div class="input-group">
                            <input
                            
                              id="passport-input-icon-left"
                              title=" "
                              v-model="patient.posiljaoc"
                              name="passport-input-icon-left"
                              required
                            >
                            <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                            <label
                            
                              class="control-label"
                              for="passport-input-icon-left"
                            >{{'Pošiljaoc'}}</label>
                            <i class="bar"></i>
                          </div>
                        </div>

                        <div class="form-group with-icon-left">
                          <div class="input-group">
                            <input
                              id="tlp-input-icon-left"
                              title=" "
                              v-model="patient.hitno"
                              name="tlp-input-icon-left"
                              required
                            >
                            <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                            <label
                              class="control-label"
                              for="tlp-input-icon-left"
                            >{{'Prioritet'}}</label>
                            <i class="bar"></i>
                          </div>
                        </div>
                        <div class="form-group with-icon-left">
                          <div class="input-group">
                            <input
                              id="emp-input-icon-left"
                              title=" "
                              v-model="patient.datum"
                              name="emp-input-icon-left"
                              required
                            >
                            <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                            <label
                              class="control-label"
                              for="emp-input-icon-left"
                            >{{'Datum uputnice'}}</label>
                            <i class="bar"></i>
                          </div>
                        </div>

                        <div class="form-group with-icon-left">
                          <div class="input-group">
                            <textarea id="katalozi" name="katalozi" ref="katalozi" >
                            {{patient.katalozi}}
                           
                            </textarea>
                            <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                            <label
                              class="control-label"
                              for="emp-input-icon-left"
                            >{{'KATALOZI'}}</label>
                            <i class="bar"></i>
                          </div>
                        </div>

                        <div class="form-group with-icon-left">
                          <div class="input-group">
                            <textarea id="pkatalozi" name="pkatalozi" ref="pkatalozi">
                            {{patient.predefinisane_pretrage}}
                           
                            </textarea>
                            <i class="glyphicon glyphicon-pencil icon-left input-icon"></i>
                            <label
                              class="control-label"
                              for="emp-input-icon-left"
                            >{{'PREDEFINISANE PRETRAGE'}}</label>
                            <i class="bar"></i>
                          </div>
                        </div>

                      </fieldset>
                    </div>
                  </div>
                </form>
              </div>

              <!--Footer-->
              <div class="modal-footer">
                <slot name="footer">
                  <button
                    type="button"
                    v-if="!noButtons"
                    :class="cancelClass"
                    @click="cancel"
                    :disabled="cancelDisabled"
                  >{{ cancelText }}</button>
                  <button
                    type="button"
                    v-if="!noButtons"
                    :class="okClass"
                    @click="ok"
                    
                  >{{ okText }}</button>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { bus } from "../../../main";
import router from "../../../router";
import { http } from "../../../../config/config.js";

export default {
  name: "uputnica-view",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    patient: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: false,
      duration: 500,
      izbor: "jmbg",
      ime: "",
      prezime: "",
      jmbg:this.patient.jmbg,
      spol: "",
      spolovi: ["MUŠKI", "ŽENSKI"],
      adresa: "",
      cities: [],
      telefon: "",
      email: "",
      // Toasts
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      datum:""
    };
  },
  computed: {
    modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted() {
    http
      .post("/postavke/sajtovi/" + this.$store.state.site, {
        token: this.$store.state.token
      })
      .then(res => {
        if (res.data.sajt.mjesta != undefined) {
          res.data.sajt.mjesta.forEach(element => {
            this.cities.push(element);
          });
        }
      })
      .then(res => {
        this.cities.sort(function(a, b) {
          return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
        });
      });

      //this.txtresize()
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    );
  },
  watch: {
    show: function(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    },
    jmbg:function(value){
      //      function validateDate(date){
      //               var regex=new RegExp("([0-9]{4}[-](0[1-9]|1[0-2])[-]([0-2]{1}[0-9]{1}|3[0-1]{1})|([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][0-9]{4})");
      //               var dateOk=regex.test(date);
      //               if(dateOk){
      //                 console.log('dobar datum')
      //                 return true
                      
      //               }else{
      //                   alert("Pogrešan datum");
      //                   this.jmbg = ""
      //                   return false
                        
                        
      //               }
      //           } 
                
      //     if(value.length >= 7){
      //        var godina = ''
      //         switch (value.substring(4,5)) {
      //           case '9':
      //                   godina = '1'+value.substring(4,7)
      //                   this.datum = value.substring(0,2)+'-'+value.substring(2,4)+'-'+godina
      //             break;
      //           case '0':
      //                   godina = '2'+value.substring(4,7)
      //                   this.datum = value.substring(0,2)+'-'+value.substring(2,4)+'-'+godina
      //             break;    
      //           default:
      //             break;
      //         }
          
      //   }
     

      // if ((value.length===13) && validateDate(this.datum)) {
      //   console.log('maticni validated:'+value)
      //   this.patient.jmbg = value

      //   var bbb=value.toString().substring(9,12)
      //   parseInt(bbb) < 500 ? (this.spol = "MUŠKI"):(this.spol = "ŽENSKI")
      //   this.patient.spol = this.spol
      //   console.log(this.spol)
      // }else{
       
             
      // } 


    }
  },
  methods: {
    txtresize(){
        console.log('katalozi')
        
         if(this.$refs.katalozi!= undefined){
        const { katalozi } = this.$refs.katalozi;
        katalozi.style.height = katalozi.scrollHeight - 4 + 'px';

        const { pkatalozi } = this.$refs.pkatalozi;
        pkatalozi.style.height = pkatalozi.scrollHeight - 4 + 'px';
         }
       
    },
    listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok() {
      this.$emit("ok");
      this.show = false;
      this.Save()
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    validateJMBG(jmbg) {
      return (
        /^\d{4}[9,0]{1}\d{8}$/.test(String(jmbg)) ||
        /^\d{4}[9,0]{1}\d{7}[P]{1}$/.test(String(jmbg))
      );
    },
    Save() {
          var datum = "";
          var temp = [];
      console.log('SACUVAJ')
      console.log(this.patient)
      if(this.patient.jmbg ==="GREŠKA"){
        console.log("GRESKA")
      }else{

     
      http
        .post("/api/uputnica/zaprimi", {
          site: this.$store.state.site,
          token: this.$store.state.token,
          patient: this.patient
        })
        .then((res) => {
          console.log("Uputnica sacuvana")
          console.log(res.data)
          res.data.data.forEach((element) => {
            temp = element.datum.split("-");
            datum =
              temp[2].substring(0, 2) +
              "." +
              temp[1] +
              "." +
              temp[0].substring(2, 4) +
              " " +
              temp[2].substring(3, 8);

            if(this.$store.state.site==="6003f7eff5e7ce7d39d4b5d7"){
              console.log("Site mikrobiologija change SID and print barkod")
              console.log(element.sid)
              var novi_sid=element.sid.substring(1,4)+element.sid.substring(0,1)+this.patient.idn
              console.log(novi_sid)
              printEPL(
              element.patient,
              novi_sid,
              element.pid,
              element.godiste,
              datum,
              element.link,
              element.code,
              this.$store.state.site,
              undefined,
              this.BrojProtokola
            );
            printEPL(
              element.patient,
              novi_sid,
              element.pid,
              element.godiste,
              datum,
              element.link,
              element.code,
              this.$store.state.site,
              undefined,
              this.BrojProtokola
            );
            if(novi_sid.includes("B")){
              console.log("Treca naljepnica")
            printEPL(
              element.patient,
              novi_sid,
              element.pid,
              element.godiste,
              datum,
              element.link,
              element.code,
              this.$store.state.site,
              undefined,
              this.BrojProtokola
            );
            }
            }else{
              console.log("Uputnica sacuvana printam barkod")
              printEPL(
              element.patient,
              element.sid,
              element.pid,
              element.godiste,
              datum,
              element.link,
              element.code,
              this.$store.state.site,
              undefined,
              this.BrojProtokola
            );
            }

          });
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../../sass/_variables.scss";

//Modals
$modal-header-padding-x: $widget-padding;
$modal-header-padding-y: 0;
$modal-header-height: $widget-header-height;
$modal-header-border: $widget-header-border;
$modal-content-border-width: 0;
$modal-content-border-radius: 0;
$modal-inner-padding: 25px;
$modal-footer-btns-padding-bottom: 20px;
$modal-footer-btns-margin-x: 10px;
$modal-md: 650px;
$modal-lg: 850px;

.vuestic-modal {
  height: 0;
  width: 0;

  // For Transitioning
  .modal {
    display: block;
  }

  .modal-dialog,
  .modal-backdrop {
    transition: all 0.5s ease;
  }

  .modal-enter .modal-dialog,
  .modal-leave-active .modal-dialog {
    opacity: 0;
    transform: translateY(-30%);
  }

  .modal-enter .modal-backdrop,
  .modal-leave-active .modal-backdrop {
    opacity: 0;
  }

  .modal-backdrop {
    opacity: 0.5;
  }

  //Modal styles

  .modal-header {
    height: $modal-header-height;
    padding: $modal-header-padding-y $modal-header-padding-x;
    border-bottom: $modal-header-border;
    font-size: $font-size-larger;
    display: flex;
    align-items: center;
  }

  .close-modal {
    margin-left: 1rem;
    font-size: $font-size-large;
    line-height: $font-size-large;
    cursor: pointer;
  }

  .modal-content {
    border-radius: $modal-content-border-radius;
  }

  .modal-footer {
    justify-content: center;
    padding: 0 $modal-inner-padding;
    padding-bottom: calc(
      #{$modal-inner-padding} - #{$modal-footer-btns-padding-bottom}
    );
    flex-wrap: wrap;
    .btn {
      margin: 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom
        $modal-footer-btns-margin-x;
    }
  }

  // .modal-dialog {
  //   box-shadow: $modal-content-box-shadow-sm-up;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/02_prijem/datatable-components/UputnicaView.vue